import axios from 'axios';
import VideoThumbnail from '../../../public/Images/video.png';
import { useState } from 'react';
import { PlayCircleIcon } from '@phosphor-icons/react';

const VideoCipherPlayer = ({
  videoId,
  isSolution = true,
  questionId = null,
  videoThumbnail = null,
  testId,
  testTitle = null,
}) => {
  const [otp, setOtp] = useState('');
  const [playbackInfo, setPlaybackInfo] = useState('');
  const [showPlayer, setShowPlayer] = useState(false);

  const user = JSON.parse(localStorage.getItem('userProfile'));

  const getVideoCipherOtp = async () => {
    if (!videoId) return;
    try {
      const res = await axios.get(`/api/video/${videoId}/getotp`);
      return {
        otp: res?.data?.data?.otp,
        playBackInfo: res?.data?.data?.playbackInfo,
      };
    } catch (err) {
      console.error(`Error fetching OTP and playback info for videoId ${videoId}`, err);
    }
  };

  const handleShowVdoCipherVideoSolution = async () => {
    const videoOtp = await getVideoCipherOtp();
    if (!videoOtp) return;

    const { otp, playBackInfo } = videoOtp;
    setOtp(otp);
    setPlaybackInfo(playBackInfo);
    setShowPlayer(true);
  };

  let thumbnail = '';
  try {
    if (playbackInfo) {
      const parsed = JSON.parse(playbackInfo);
      thumbnail = parsed?.poster || '';
    }
  } catch {}

  return (
    <div>
      {isSolution && (
        <div className="font-medium text-[13px] text-[var(--q3-neutral-light)] cursor-pointer">VIDEO SOLUTION</div>
      )}

      {/* ✅ STYLE MATCHING SECOND PLAYER ONLY WHEN isSolution === true */}
      <div className={`my-3 relative ${isSolution ? 'w-full max-w-[300px]' : 'w-full'}`}>
        {!showPlayer ? (
          <div className="relative cursor-pointer" onClick={handleShowVdoCipherVideoSolution}>
            <img
              src={thumbnail || videoThumbnail || VideoThumbnail}
              alt="Video Thumbnail"
              className={isSolution ? 'max-w-[300px] rounded-lg' : 'w-full rounded-xl'}
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <PlayCircleIcon size={35} weight="fill" />
            </div>
          </div>
        ) : (
          <>
            {isSolution ? (
              <iframe
                src={`https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}`}
                allow="encrypted-media"
                allowFullScreen
                loading="lazy"
                style={{
                  border: 0,
                  borderRadius: '16px',
                  display: 'block',
                  width: window.innerWidth < 768 ? '300px' : '400px',
                  height: window.innerWidth < 768 ? '200px' : '300px',
                }}
              />
            ) : (
              <div className="w-full aspect-video">
                <iframe
                  src={`https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}`}
                  allow="encrypted-media"
                  allowFullScreen
                  loading="lazy"
                  style={{
                    border: 0,
                    borderRadius: '16px',
                    width: '100%',
                    height: '100%',
                    display: 'block',
                  }}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default VideoCipherPlayer;
